import $ from 'jquery';
import { checkboxChange } from './eventsCriteria';
import { editAndDeleteButtons } from './allCriteria';

export function addCriterium() {
  $('.add-more-school-js').click(function() {
    $('.school-criteria-js').append($('.school-criterium--js').html());
    $('.school-criterium-status--js').attr('placeholder', 'Critério');
    $('.school-criteria-js .criterium-field-js:last').prop('disabled', false);
    $('.school-criteria-js .empty-criterium').detach();
    checkboxChange();
    editAndDeleteButtons();
  });

  $('.add-more-project-js').click(function() {
    $('.project-criteria-js').append($('.project-criterium--js').html());
    $('.project-criterium-status--js').attr('placeholder', 'Critério');
    $('.project-criteria-js .criterium-field-js:last').prop('disabled', false);
    $('.project-criteria-js .empty-criterium').detach();
    checkboxChange();
    editAndDeleteButtons();
  });

  $('.add-more-category-js').click(function() {
    $('.category-criteria-js').append($('.category-criterium--js').html());
    $('.category-criterium-status--js').attr('placeholder', 'Categoria');
    $('.category-criteria-js .criterium-field-js:last').prop('disabled', false);
    $('.category-criteria-js .empty-criterium').detach();

    checkboxChange();
    editAndDeleteButtons();
  });

  $('.add-more-socioemotional-js').click(function() {
    var category = $(this).data('value');

    $('.socioemotional-'+category+'-criteria-js').append($('.socioemotional-criterium--js').html());
    $('.socioemotional-criterium-status--js').attr('placeholder', 'Critério');
    $('.socioemotional-'+category+'-criteria-js .criterium-field-js:last').prop('disabled', false);
    $('.socioemotional-'+category+'-criteria-js .empty-criterium').detach();
    $('.socioemotional-'+category+'-criteria-js .category-id-field-js:last').val(category);

    checkboxChange();
    editAndDeleteButtons();
  });

  $('.add-more-diary-js').click(function() {
    var criteriumType = $(this).data('value').toLowerCase();
    $('.'+criteriumType+'-criteria-js').append($('.'+criteriumType+'-criterium--js').html());
    $('.'+criteriumType+'-criterium-status--js').attr('placeholder', 'Critério');
    $('.'+criteriumType+'-criteria-js .criterium-field-js:last').prop('disabled', false);
    $('.'+criteriumType+'-criteria-js .empty-criterium').detach();

    var categoryId = criteriumType.split('-')[1]
    $('.'+criteriumType+'-criteria-js .category-id-field-js:last').val(categoryId);

    checkboxChange();
    editAndDeleteButtons();
  });
}
